export function compareSrmVersions(left, right) {
  const parse = value => String(value ?? "")
    .trim()
    .replace(/^v/i, "")
    .split("-")[0]
    .split(".")
    .map(part => Number.parseInt(part, 10) || 0);

  const a = parse(left);
  const b = parse(right);
  const length = Math.max(a.length, b.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (a[index] || 0) - (b[index] || 0);
    if (difference !== 0) return Math.sign(difference);
  }
  return 0;
}

export function isSrmUpdateNewer(update, currentConfig) {
  if (!update || !currentConfig) return false;

  if (update.version) {
    const versionComparison = compareSrmVersions(update.version, currentConfig.version);
    if (versionComparison !== 0) return versionComparison > 0;
  }

  const incomingBuild = Number(update.build_no);
  const currentBuild = Number(currentConfig.build_no);
  return Number.isFinite(incomingBuild)
    && Number.isFinite(currentBuild)
    && incomingBuild > currentBuild;
}

export function srmUpdateIdentity(update) {
  return [update?.version || "", update?.build_no ?? "", update?.published_at || ""].join("|");
}

export function srmUpdateRequiresLogout(update) {
  return update?.require_logout === true
    || update?.require_logout === 1
    || update?.require_logout === "1"
    || update?.require_logout === "true";
}

export function countSrmChangelogItems(changelog) {
  const text = String(changelog || "").trim();
  if (!text) return 0;

  const lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  const emojiHeadings = lines.filter(line => {
    if (!/^\p{Extended_Pictographic}/u.test(line)) return false;
    return !/^🚀\s*(what(?:'|’)s new|srm\s+v?\d)/i.test(line);
  });
  if (emojiHeadings.length) return emojiHeadings.length;

  const listItems = lines.filter(line => /^(?:[-*•]|\d+[.)])\s+/.test(line));
  if (listItems.length) return listItems.length;

  // Plain-text changelogs commonly use one blank-line-separated paragraph
  // per change. Ignore a leading "What's new" title when present.
  const paragraphs = text.split(/(?:\r?\n){2,}/).map(value => value.trim()).filter(Boolean);
  if (/what(?:'|’)s new|^srm\s+v?\d/i.test(paragraphs[0] || "")) paragraphs.shift();
  return paragraphs.length;
}
